import { useQuery } from '@tanstack/react-query';
import { top149Api, Top149ProvinceQueryParamsSchema } from '../../../services/top149Api';
import { z } from 'zod';

interface UseTop149ProvinceQueryParams {
	year?: number;
	sortBy?: string;
	sortOrder?: 'asc' | 'desc';
	maTinh?: string;
	tenTinh?: string;
	enabled?: boolean;
}

export function useTop149ProvinceQuery(params: UseTop149ProvinceQueryParams) {
	const { year, sortBy, sortOrder, maTinh, tenTinh, enabled = true } = params;

	return useQuery({
		queryKey: ['top149', 'by-province', year, sortBy, sortOrder, maTinh, tenTinh],
		queryFn: async () => {
			if (!year) {
				throw new Error('Year is required');
			}

			const queryParams: z.infer<typeof Top149ProvinceQueryParamsSchema> = {
				year,
				sortBy,
				sortOrder,
				maTinh,
				tenTinh
			};

			return await top149Api.getTop149ByProvince(queryParams);
		},
		enabled: enabled && year !== undefined,
		staleTime: 5 * 60 * 1000,
	});
}

export function useTop149MergedProvinceQuery(params: UseTop149ProvinceQueryParams) {
	const { year, sortBy, sortOrder, maTinh, tenTinh, enabled = true } = params;

	return useQuery({
		queryKey: ['top149', 'by-province-merged', year, sortBy, sortOrder, maTinh, tenTinh],
		queryFn: async () => {
			if (!year) {
				throw new Error('Year is required');
			}

			const queryParams: z.infer<typeof Top149ProvinceQueryParamsSchema> = {
				year,
				sortBy,
				sortOrder,
				maTinh,
				tenTinh
			};

			return await top149Api.getTop149ByProvince(queryParams, true);
		},
		enabled: enabled && year !== undefined,
		staleTime: 5 * 60 * 1000,
	});
}
